import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import { UINotificationType } from '~/types/UINotification';

export type BrandingState = {
  readonly isUploadingLogo: boolean;
  readonly uploadFileError: string;
  readonly uploadLogoErrorCode: string;
  readonly uploadLogoNotifType: Maybe<UINotificationType>;

  readonly isUpdatingColor: boolean;
  readonly updateColorNotifType: Maybe<UINotificationType>;
};

const initialState: BrandingState = {
  isUploadingLogo: false,
  uploadFileError: '',
  uploadLogoErrorCode: '',
  uploadLogoNotifType: null,

  isUpdatingColor: false,
  updateColorNotifType: null,
};

function brandingReducer(state: BrandingState = initialState, action: ActionTypes): BrandingState {
  switch (action.type) {
    case ActionKeys.USER_ASSET_UPLOAD_AND_PUBLISH_LOGO:
      return {
        ...state,
        isUploadingLogo: true,
        uploadFileError: '',
        uploadLogoErrorCode: '',
        uploadLogoNotifType: null,
      };
    case ActionKeys.USER_ASSET_UPLOAD_AND_PUBLISH_LOGO_SUCCESS:
      return {
        ...state,
        isUploadingLogo: false,
        uploadLogoNotifType: UINotificationType.SUCCESS,
      };
    case ActionKeys.USER_ASSET_UPLOAD_AND_PUBLISH_LOGO_ERROR:
      return {
        ...state,
        isUploadingLogo: false,
        uploadLogoErrorCode: action.payload.errorCode,
        uploadLogoNotifType:
          action.payload.errorCode === 'unknown_error' ? UINotificationType.ERROR : null,
      };
    case ActionKeys.USER_BRAND_UPDATE_COLORS:
      return {
        ...state,
        isUpdatingColor: true,
        updateColorNotifType: null,
      };
    case ActionKeys.USER_BRAND_UPDATE_COLORS_SUCCESS:
      return {
        ...state,
        isUpdatingColor: false,
        updateColorNotifType: UINotificationType.SUCCESS,
      };
    case ActionKeys.USER_BRAND_UPDATE_COLORS_ERROR:
      return {
        ...state,
        isUpdatingColor: false,
        updateColorNotifType: UINotificationType.ERROR,
      };
    case ActionKeys.BRANDING_SET_UPLOAD_FILE_ERROR:
      return {
        ...state,
        uploadFileError: action.payload.error,
      };
    case ActionKeys.BRANDING_CLOSE_UPLOAD_LOGO_NOTIF:
      return {
        ...state,
        uploadLogoNotifType: null,
      };
    case ActionKeys.BRANDING_CLOSE_UPDATE_COLOR_NOTIF:
      return {
        ...state,
        updateColorNotifType: null,
      };
    default:
      return state;
  }
}

export default brandingReducer;
